// extracted by mini-css-extract-plugin
export var pillWrapper = "_jc-0";
export var showOverflow = "_jc-1";